import React, { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { Check as CheckIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

/**
 * Modo de análisis del chat como menú desplegable (teléfonos: los tres
 * botones de OptimizedChatComponent ocupan una fila entera). Mismo aspecto
 * que ChatModelSelector.
 * `actions`: [{key, label, Icon, locked}] -- `locked` = el plan no lo incluye.
 */
const ChatModeSelector = ({ actions, value, onChange, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const selected = actions.find((action) => action.key === value) || actions[0];
  const { Icon } = selected;

  const choose = (key) => {
    setAnchorEl(null);
    onChange(key);
  };

  return (
    <>
      <Button
        startIcon={<Icon />}
        endIcon={<ExpandMoreIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-label={`Modo: ${selected.label}`}
        sx={{
          color: 'var(--wb-x-text-cccccc, #ccc)',
          '&:hover': { backgroundColor: 'var(--wb-x-bg-160565b7, #160565b7)' },
          '&.Mui-disabled': { color: 'var(--wb-x-text-cccccc66, rgba(204,204,204,0.4))' },
          borderRadius: 2,
          textTransform: 'none',
          px: 1.5,
          maxWidth: '100%',
          '& .MuiButton-startIcon, & .MuiButton-endIcon': { flexShrink: 0 }
        }}
        type="button"
      >
        <Typography component="span" noWrap sx={{ fontSize: 'inherit' }}>{selected.label}</Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          sx: {
            backgroundColor: 'var(--wb-bg-surface-alt)',
            color: 'var(--wb-text)',
            minWidth: 240,
            '& .MuiMenuItem-root:hover': { backgroundColor: 'var(--wb-accent-tint)' }
          }
        }}
      >
        {actions.map((action) => {
          const { Icon: ItemIcon } = action;
          const item = (
            <MenuItem key={action.key} selected={action.key === selected.key} disabled={action.locked} onClick={() => choose(action.key)}>
              <ListItemIcon sx={{ color: 'var(--wb-text-soft)' }}><ItemIcon fontSize="small" /></ListItemIcon>
              <ListItemText
                primary={action.label}
                secondary={action.locked ? 'Disponible en planes de pago' : null}
                primaryTypographyProps={{ sx: { color: 'var(--wb-text)', fontSize: '0.9rem' } }}
                secondaryTypographyProps={{ sx: { color: 'var(--wb-text-soft)', fontSize: '0.75rem' } }}
              />
              {action.key === selected.key && <CheckIcon fontSize="small" sx={{ ml: 1, color: 'var(--wb-accent)' }} />}
            </MenuItem>
          );
          return action.locked ? (
            <Tooltip key={action.key} title="Se habilita en un plan de pago" placement="right">
              <span>{item}</span>
            </Tooltip>
          ) : item;
        })}
      </Menu>
    </>
  );
};

export default ChatModeSelector;
